import {combineReducers} from 'redux';
import { BoxReducer } from './BoxReducer';
import { AuthReducer } from './AuthReducer';
import { FormsReducer } from './FormsReducer';
import { JobReducer } from './JobReducer';
import { ContractLocationReducer } from './ContractLocationReducer';
import { ProjectCodeReducer } from './ProjectCodeReducer';
import { AccountCodeReducer } from './AccountCodeReducer';

const rootReducers = combineReducers({
	box: BoxReducer,
    auth: AuthReducer,
	forms: FormsReducer,
	jobType: JobReducer,
	contractLocation: ContractLocationReducer,
	projectCodes: ProjectCodeReducer,
	accountCodes: AccountCodeReducer
})

export default rootReducers;